import { LegislationRelationModel } from "./legislation-relation";
import { EURelationModel } from "./eu-relation";
import { AppSettings } from "../../app-settings";
import { ParagraphFilterModel } from "../../desktop/models/paragraph-filter";
import { CaseRelationModel } from "../../desktop/models/case-relation";
import { DocumentRelationCollection } from "../../desktop/collections/document-relations";
import { SiblingModel } from "../../desktop/models/stage";
import { ParallelCitationModel } from "../../desktop/models/parallel-citation";
import { PublisherModel } from "../../desktop/models/publisher";
import { DisplayKeyParagraphCollection } from "../../desktop/collections/display-key-paragraphs";
import { DisplayKeyParagraphModel } from "../../desktop/models/display-key-paragraph";
import { KeyParagraphModel } from "../../desktop/models/key-paragraph";
import { KeyParagraphCollection } from "../../desktop/collections/key-paragraphs";
import { ReportDetailModel } from "../../desktop/models/report-detail";
import {BaseRelationModel} from "../../desktop/models/base-relation";

const def = {
    urlRoot: `${AppSettings.DocumentApiUrlPrefix}document`,
        relations: [{
            type: Backbone.Many,
            key: "ParagraphFilters",
            relatedModel: ParagraphFilterModel
        },
            {
                type: Backbone.Many,
                key: "Considered",
                collectionType: DocumentRelationCollection
            },
            {
                type: Backbone.Many,
                key: "NOCList",
                relatedModel: CaseRelationModel
            },
            {
                type: Backbone.Many,
                key: "Subsequent",
                collectionType: DocumentRelationCollection
            },
            {
                type: Backbone.Many,
                key: "AmendedItems",
                relatedModel: LegislationRelationModel,
            }, {
                type: Backbone.Many,
                key: "AmendingItems",
                relatedModel: LegislationRelationModel,
            },
            {
                type: Backbone.Many,
                key: "SimilarCases",
                collectionType: DocumentRelationCollection
            },
            {
                type: Backbone.Many,
                key: "LegislationConsidered",
                collectionType: DocumentRelationCollection
            },
            {
                type: Backbone.Many,
                key: "Stages",
                relatedModel: SiblingModel
            },
            {
                type: Backbone.Many,
                key: "ParallelCitations",
                relatedModel: ParallelCitationModel
            },
            {
                type: Backbone.Many,
                key: "Publishers",
                relatedModel: PublisherModel
            },
            {
                type: Backbone.Many,
                key: "DisplayPowerParagraphs",
                collectionType: DisplayKeyParagraphCollection
            },
            {
                type: Backbone.Many,
                key: "DisplayQuotedParagraphs",
                relatedModel: DisplayKeyParagraphModel
            },
            {
                type: Backbone.Many,
                key: "PowerParagraph",
                relatedModel: KeyParagraphModel,
                collectionType: KeyParagraphCollection
            },
            {
                type: Backbone.Many,
                key: "ReportDetails",
                relatedModel: ReportDetailModel
            },
            {
                type: Backbone.Many,
                key: "CitedCases",
                relatedModel: EURelationModel
            },
            {
                type: Backbone.Many,
                key: "CitingCases",
                relatedModel: EURelationModel
            },
            {
                type: Backbone.Many,
                key: "CitedLegislation",
                relatedModel: EURelationModel
            },
            {
                type: Backbone.Many,
                key: "LegalBasis",
                relatedModel: EURelationModel
            },
            {
                type: Backbone.Many,
                key: "LegalBasisFor",
                relatedModel: EURelationModel
            },
            {
                type: Backbone.Many,
                key: "CitingLegislation",
                relatedModel: EURelationModel
            },
            {
                type: Backbone.Many,
                key: "EUAmendingItems",
                relatedModel: EURelationModel
            },
            {
                type: Backbone.Many,
                key: "EUAmendedItems",
                relatedModel: EURelationModel
            },
            {
                type: Backbone.Many,
                key: "RelatedDocuments",
                relatedModel: BaseRelationModel
            },
            {
                type: Backbone.Many,
                key: "PreciseLegalPoints",
                relatedModel: EURelationModel
            },
            {
                type: Backbone.Many,
                key: "RelatedArticles",
                relatedModel: EURelationModel
            },
            {
                type: Backbone.Many,
                key: "CitingDomesticCases",
                relatedModel: EURelationModel
            },
            {
                type: Backbone.Many,
                key: "CitedDomesticCases",
                relatedModel: EURelationModel
            },
            {
                type: Backbone.Many,
                key: "ImplementingDomesticLegislation",
                relatedModel: BaseRelationModel
            },
            {
                type: Backbone.Many,
                key: "ImplementedEULegislation",
                relatedModel: EURelationModel
            }
        ],
        defaults: {
            Populated: false,
            Visible: false,
            Animated: false,
            Expired: false,
            Highlighting: false,
            Publishers: [],
            ParallelCitations: [],
            Stages: [],
            LegislationConsidered: [],
            Subsequent: [],
            NOCList: [],
            Considered: [],
            ParagraphFilters: [],
            DisplayPowerParagraphs: [],
            DisplayQuotedParagraphs: [],
            PdfLinks: [],
            ReportDetails: [],
            ImplementingDomesticLegislation: [],
            ImplementedEULegislation: []
    }
};

export default def;



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/document-defaults.ts